export default {
  SONOTA: 99,
}
